// ink-component
import React, { useContext } from 'react';
import { ThemeContext } from 'styled-components';

import NavItemElement from '../../../_common/NavItemElement/NavItemElement';

export interface SubNavAnchorProps extends React.AnchorHTMLAttributes<HTMLAnchorElement> {
  /** Renders this element as active */
  active?: boolean;
}

/**
 * @group SubNav
 * @purpose Anchor item of SubNav
 * @order 2
 * @HTMLType HTMLAnchorElement
 */
const SubNavAnchor = (props: SubNavAnchorProps) => {
  const { className, style, active, ...otherProps } = props;
  const currentTheme = useContext(ThemeContext);

  const theme = { ...currentTheme, active };

  return <NavItemElement theme={theme} tabIndex={0} as="a" {...otherProps} />;
};

SubNavAnchor.defaultProps = {
  active: undefined,
};

SubNavAnchor.displayName = 'SubNav.Anchor';

export default SubNavAnchor;
